<template>
    <div class="mx-auto">
        <div class="loader" v-if="loading"></div>
        <div v-else>
            <page-title :title="$t('places.title')" :showTitle="false"></page-title>

            <div class="btn-group" role="group">
                <button type="button"
                        class="btn btn-primary"
                        @click="backToRegister">
                    <i class="fas fa-th-list"></i> {{ $t('backToList') }}
                </button>
            </div>

            <div class="card mt-3">
                <div class="card-header bg-primary text-white">
                    <div class="card-title h5 m-0">{{ $t('places.location') }}</div>
                </div>
                <div class="card-body">
                    <div class="form-group col-12">
                        <label>{{ $t('places.name') }}</label>
                        <input type="text" class="form-control" readonly v-model="place.name">
                    </div>
                </div>
            </div>

            <div class="card mt-3">
                <div class="card-header bg-primary text-white">
                    <div class="card-title h5 m-0">{{ $t('places.halls') }}</div>
                </div>
                <div class="card-body">
                    <hall v-for="(hall,index) in place.halls" :key="index" :hall="hall"></hall>
                </div>
            </div>

            <div class="card mt-3">
                <div class="card-header bg-primary text-white">
                    <div class="card-title h5 m-0">{{ $t('address.cardTitle') }}</div>
                </div>
                <div class="card-body">
                    <app-address :address="place.address"></app-address>
                </div>
            </div>

            <div class="card mt-3">
                <div class="card">
                    <div class="card-header bg-primary text-white">
                        <div class="card-title h5 m-0">{{ $t('contactPerson') }}</div>
                    </div>
                    <div v-if="showContactPerson">
                        <div class="card-body">
                            <contact-person :person="place.contactPerson"></contact-person>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card mt-3">
                <div class="card">
                    <div class="card-header bg-primary text-white">
                        <div class="card-title h5 m-0">{{ $t('places.otherFields') }}</div>
                    </div>
                    <div class="card-body">
                        <otherfields :otherFields="place.otherFields"></otherfields>
                    </div>
                </div>
            </div>

            <div class="mt-3" v-if="place">
                <AuxiliaryRegisterDetails :entryId="place.auxRegisterEntityId"></AuxiliaryRegisterDetails>
            </div>
        </div>
    </div>
</template>

<script>
    import HallComponent from '@/components/hall/HallDetails';
    import AddressComponent from '@/components/address/AddressDetails';
    import { PlaceDetails, Hall } from '@/models/models'
    import ContactPersonComponent from '@/components/person/ContactPersonDetails';
    import OtherFields from '@/components/otherFields/OtherFieldsDetails.vue';
    import AuxiliaryRegisterDetails from '@/components/dynamic/AuxiliaryRegisterDetails'
    import PageTitle from '@/components/common/PageTitle';

    export default {
        components: {
            'contact-person': ContactPersonComponent,
            'hall': HallComponent,
            'app-address': AddressComponent,
            'otherfields': OtherFields,
            AuxiliaryRegisterDetails,
            PageTitle
        },
        props: {
            id: {
                type: Number,
                required: true
            },
            returnUrl: {
                type: String,
                default() {
                    return '';
                }
            }
        },
        data() {
            return {
                place: new PlaceDetails(),
                loading: false,
                showContactPerson: false,
            }
        },
        methods: {
            loadData() {
                this.loading = true;
                this.$http.get(`/api/places/GetDetails/${this.id}`).then(result => {
                    this.place = new PlaceDetails(result.data);
                    if (this.place.contactPerson && this.place.contactPerson.firstName) {
                        this.showContactPerson = true;
                    }
                }).catch(error => {
                    this.$vs.notify({
                        title: this.$t('buttons.load.btnText'),
                        text: this.$helpers.errorText(error),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration
                    })
                }).then(() => { this.loading = false; });
            },
            backToRegister() {
                this.$router.push(this.returnUrl || '/registers/places');
            },
        },
        mounted() {
            this.loadData();
            this.place.halls.push(new Hall());
        }
    }
</script>

<style scoped>
    input[readonly] {
        background-color: whitesmoke;
    }

    textarea[readonly] {
        background-color: whitesmoke;
    }
</style>
